import { useAppDispatch, useAppSelector } from "./redux";
import { setLanguage, setTheme } from "@/store/slices/settingsSlice";
import { useTranslation } from "react-i18next";

export const useSettings = () => {
  const dispatch = useAppDispatch();
  const { language, theme } = useAppSelector((state) => state.settings);
  const { i18n } = useTranslation();

  const changeLanguage = (newLanguage: string) => {
    dispatch(setLanguage(newLanguage));
    i18n.changeLanguage(newLanguage);
  };

  const changeTheme = (newTheme: string) => {
    dispatch(setTheme(newTheme));
  };

  return {
    language,
    theme,
    changeLanguage,
    changeTheme,
  };
};
